import React from "react";

import DashboardPage from "./pages/DashboardPage";
import UploadDataPage from "./pages/UploadDataPage";
import DebugPage from "./pages/DebugPage";
import ConfigurationPage from "./pages/ConfigurationPage";
import SheetsPage from "./pages/SheetsPage";
import TransactionsPage from "./pages/TransactionsPage";
import LogoutPage from "./pages/LogoutPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ValidatePage from "./pages/ValidatePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import MyAccountPage from "./pages/MyAccountPage";

export const authRoutes = [
  {
    path: "/",
    component: DashboardPage,
    isPrivate: true,
    isMenu: false
  },
  {
    path: "/dashboard",
    component: DashboardPage,
    isPrivate: true,
    isMenu: false
  },
  {
    path: "/uploadData",
    component: UploadDataPage,
    isPrivate: true,
    isMenu: false
  },
  {
    path: "/configuration/debug",
    component: DebugPage,
    isPrivate: true,
    isMenu: false
  },
  {
    path: "/configuration",
    component: ConfigurationPage,
    isPrivate: true,
    isMenu: false
  },
  {
    path: "/configuration/:identifier",
    component: ConfigurationPage,
    isPrivate: true
  },
  {
    path: "/sheets",
    component: SheetsPage,
    isPrivate: true,
    isMenu: false
  },
  {
    path: "/login",
    component: LoginPage,
    isPrivate: false
  },
  {
    path: "/forgotPassword",
    component: ForgotPasswordPage,
    isPrivate: false
  },
  {
    path: "/forgotPassword/:requestCode",
    component: ForgotPasswordPage,
    isPrivate: false
  },
  {
    path: "/logout",
    component: LogoutPage,
    isPrivate: false
  },
  {
    path: "/mon-compte",
    component: MyAccountPage,
    isPrivate: true
  },
  {
    path: "/mon-compte/:identifier",
    component: MyAccountPage,
    isPrivate: true
  },
  {
    path: "/register",
    component: RegisterPage,
    isPrivate: false
  },
  {
    path: "/validate/:validationToken",
    component: ValidatePage,
    isPrivate: false
  },
  {
    path: "/transactions/:identifier",
    component: TransactionsPage,
    isPrivate: true
  }
];
